import { render, staticRenderFns } from "./AccountReg.vue?vue&type=template&id=30ec3820&"
import script from "./AccountReg.vue?vue&type=script&lang=js&"
export * from "./AccountReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports